/* eslint-disable @typescript-eslint/no-explicit-any */
import { ComponentType } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { ConfirmDialogComponent } from '../components/confirm-dialog/confirm-dialog.component';

@Injectable()
export class ConfirmDialogService {
  constructor(private matDialog: MatDialog) {}

  open(data: any): Observable<boolean> {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.hasBackdrop = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '30%';
    dialogConfig.minWidth = '360px';

    dialogConfig.data = data;
    const confirmDialogRef = this.matDialog.open(
      ConfirmDialogComponent,
      dialogConfig
    );

    return confirmDialogRef.afterClosed();
  }

  openAnyComponent<T>(
    component: ComponentType<T>,
    data: any,
    dialogConfig?: MatDialogConfig | null
  ): MatDialogRef<any> {
    if (!dialogConfig) {
      dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = false;
      dialogConfig.hasBackdrop = false;
      dialogConfig.autoFocus = true;
      dialogConfig.width = '40%';
      dialogConfig.minWidth = '360px';
    }

    dialogConfig.data = data;
    return this.matDialog.open(component, dialogConfig);
  }
}
